import {useClient, useDictionary} from '@adamlip/okeoke.client';
import {Accordion, AccordionItem, Divider, Drawer, DrawerContent, DrawerFooter, DrawerHeader} from '@heroui/react';
import {useEffect, useState} from 'react';
import {NumericFormat} from 'react-number-format';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import NumberFlow from '@number-flow/react';

export default function VipReserveModal({isOpen, setIsOpen, onSuccess, onCancel, data, paymentsNeeded, orderItemsAssembled, order}) {
	const {getValue} = useDictionary();
	const {getName} = useClient();

	const {deliveryCost, depositPrice: sumDepositPrice, packagingDiscountPrice, sumPrice, sumServiceFee} = order?.order || {};

	const [items, setItems] = useState([]);
	const [reservedMoney, setReservedMoney] = useState(0);
	const [reservedPoints, setReservedPoints] = useState(0);
	const [totalCardDiscount, setTotalCardDiscount] = useState(0);
	const [totalCouponDiscount, setTotalCouponDiscount] = useState(0);
	const [totalDiscount, setTotalDiscount] = useState(0);
	const [deductFromPayment, setDeductFromPayment] = useState(0);
	const [coupons, setCoupons] = useState([]);

	const handleClose = () => {
		reset();
		setIsOpen(!isOpen);
	};

	const handleOk = () => {
		if (typeof onSuccess === 'function') onSuccess({sumPaymentsNeeded: paymentsNeeded - totalDiscount});
		handleClose();
	};

	const handleCancel = () => {
		if (typeof onCancel === 'function') onCancel();
		handleClose();
	};

	const getSelectedModifiers = (item) => {
		let modifierArray = [];
		if (item?.modifierGroups?.length > 0) {
			for (let group of item?.modifierGroups) {
				if (group?.modifiers?.length > 0) {
					for (let modifier of group?.modifiers) {
						if (modifier?.count > 0) {
							modifierArray = [...modifierArray, modifier];
						}
					}
				}
			}
		}
		return modifierArray;
	};

	const reset = () => {
		setItems([]);
		setReservedMoney(0);
		setReservedPoints(0);
		setTotalCardDiscount(0);
		setTotalCouponDiscount(0);
		setTotalDiscount(0);
		setCoupons([]);
	};

	useEffect(() => {
		if (data) {
			setItems(data.items);
			setReservedMoney(data.reservedMoney);
			setReservedPoints(data.reservedPoints);
			setTotalCardDiscount(data.totalCardDiscount);
			setTotalCouponDiscount(data.totalCouponDiscount);
			setTotalDiscount(data.totalDiscount);
			setCoupons(data.coupons);
			setDeductFromPayment(data.deductFromPayment);
		}
	}, [data]);

	return (
		<Drawer
			isOpen={isOpen}
			onOpenChange={() => {
				handleClose();
			}}
			size={totalDiscount > 0 ? '2xl' : 'sm'}
			placement='bottom'>
			<DrawerContent>
				{(onClose) => (
					<>
						<DrawerHeader>
							<div className='font-bold text-xl'>{getValue('app_v2_vip_reserve_modal_title')}</div>
						</DrawerHeader>
						<DrawerHeader className='flex flex-col gap-2 overflow-y-scroll overflow-x-hidden px-2'>
							{totalDiscount <= 0 && getValue('app_v2_vip_reserve_modal_no_discount')}
							{totalDiscount > 0 && (
								<>
									<Accordion
										variant='splitted'
										className='px-0'
										classNames={{
											base: 'px-0',
										}}
										itemClasses={{
											trigger: 'py-3',
											base: 'px-0',
										}}>
										{coupons.length > 0 && (
											<AccordionItem
												key={'coupons'}
												title={getValue('app_v2_vip_reserve_modal_coupons')}
												classNames={{
													base: 'group-[.is-splitted]:bg-default/50',
												}}>
												<div className='flex flex-col gap-2'>
													{coupons
														?.filter((coupon) => coupon?.success)
														?.map((coupon) => {
															return (
																<div key={coupon.data.couponCode} className='mr-1 mb-1 flex flex-row gap-2 items-center w-full justify-between bg-background p-2 rounded-md'>
																	<p className='font-medium'>{coupon.data.coupon.name}</p>
																	<NumericFormat value={coupon?.data?.couponValue} displayType={'text'} thousandSeparator={' '} suffix={' Ft'} />
																</div>
															);
														})}
												</div>
											</AccordionItem>
										)}
										<AccordionItem
											key={'items'}
											title={getValue('app_v2_vip_reserve_modal_items')}
											classNames={{
												base: 'group-[.is-splitted]:bg-default/50',
											}}>
											{items.length > 0 && (
												<>
													<div className='flex flex-col gap-1'>
														{items.map((item) => {
															const {depositPrice, price, sumPriceUnit} = orderItemsAssembled?.[item.uid] || {};
															//console.log("!!!!!!", item)
															// console.log(
															//   "??????",
															//   orderItemsAssembled?.[item.uid]
															// )
															return (
																<div key={item.uid} className='odd:bg-default/50 p-2 rounded-general'>
																	<div className=''>{item.name}</div>
																	<div className='flex gap-1 items-center text-sm opacity-70'>
																		<div className=''>{getValue('app_v2_vip_reserve_modal_item_price')}:</div>
																		<div className='grow text-right flex justify-end gap-2'>
																			<div className=' text-right'>{+price} Ft</div>
																		</div>
																	</div>
																	<div className=''>
																		{getSelectedModifiers(orderItemsAssembled?.[item.uid]).map((modifier) => (
																			<div key={modifier.orderModifierUUID} className='flex gap-1 items-center text-sm opacity-70'>
																				<div className=''>
																					{modifier.count} {getName(modifier.name)}
																				</div>
																				<div className='grow text-right flex justify-end gap-2'>
																					<div className=' text-right'>{modifier.price * modifier.count} Ft</div>
																				</div>
																			</div>
																		))}
																	</div>
																	{depositPrice !== 0 && (
																		<div className='flex gap-1 items-center text-sm opacity-70'>
																			<div className=''>{getValue('app_v2_vip_reserve_modal_depositPrice')}:</div>
																			<div className='grow text-right flex justify-end gap-2'>
																				<div className=''>{+depositPrice} Ft</div>
																			</div>
																		</div>
																	)}
																	{item?.packageDiscountPrice !== 0 && (
																		<div className='flex gap-1 items-center text-sm opacity-70'>
																			<div className=''>{getValue('app_v2_vip_reserve_modal_package_discountPrice')}</div>
																			<div className='grow text-right flex justify-end gap-2'>
																				{item?.packagePrice !== item?.packageDiscountPrice && <div className='line-through'>{item?.packagePrice} Ft</div>}
																				<div className=''>{item?.packageDiscountPrice} Ft</div>
																			</div>
																		</div>
																	)}
																	{item?.price - item.reducedPrice > 0 && (
																		<div className='flex gap-1 items-center text-sm opacity-70'>
																			<div className=''>{getValue('app_v2_vip_reserve_modal_item_discount')}:</div>
																			<div className='grow text-right flex justify-end gap-2'>
																				<div className=''>-{item?.price - item.reducedPrice} Ft</div>
																			</div>
																		</div>
																	)}

																	<div className='flex gap-1 items-center text-sm opacity-70'>
																		<div className=''>{getValue('app_v2_vip_reserve_modal_item_sum_price')}</div>
																		<div className='grow text-right flex justify-end gap-2'>
																			{+item?.price - +item.reducedPrice > 0 && (
																				<div className='line-through'>
																					{+sumPriceUnit + +depositPrice + +item.packageDiscountPrice}
																					Ft
																				</div>
																			)}
																			<div className=''>{+item?.reducedPrice + +depositPrice + +item.packageDiscountPrice} Ft</div>
																		</div>
																	</div>
																	{Object.values(item?.coupons)?.length > 0 && (
																		<div>
																			<Divider className='my-1 bg-default' />
																			<h1 className=' font-medium text-sm'>{getValue('app_v2_vip_reserve_modal_item_coupons')}:</h1>
																			{Object.values(item?.coupons)?.map((coupon) => {
																				return (
																					<div key={coupon?.code} className='flex gap-1 items-center text-sm opacity-70'>
																						<div className=''>{coupons?.find((c) => c?.data?.couponCode === coupon?.code)?.data?.coupon?.name}</div>
																						<div className='grow text-right'>{coupon?.value} Ft</div>
																					</div>
																				);
																			})}
																		</div>
																	)}
																</div>
															);
														})}
													</div>
												</>
											)}
										</AccordionItem>
										<AccordionItem
											key={'discounts'}
											title={`${getValue('app_v2_vip_reserve_modal_discounts')}`}
											classNames={{
												base: 'group-[.is-splitted]:bg-default/50',
											}}>
											{reservedMoney > 0 && (
												<>
													<div className='flex items-center justify-between'>
														<div className=''>{getValue('app_v2_vip_reserve_modal_reserved_money')}</div>
														<div className=''>{reservedMoney}</div>
													</div>
												</>
											)}
											{reservedPoints > 0 && (
												<>
													<div className='flex items-center justify-between'>
														<div className=''>{getValue('app_v2_vip_reserve_modal_reserved_points')}</div>
														<div className=''>{reservedPoints}</div>
													</div>
												</>
											)}
											{totalCardDiscount > 0 && (
												<>
													<div className='flex items-center justify-between'>
														<div className=''>{getValue('app_v2_vip_reserve_modal_total_card_discount')}</div>
														<div className=''>{totalCardDiscount}</div>
													</div>
												</>
											)}

											{totalCouponDiscount > 0 && (
												<>
													<div className='flex items-center justify-between'>
														<div className=''>{getValue('app_v2_vip_reserve_modal_total_coupon_discount')}</div>
														<div className=''>{totalCouponDiscount}</div>
													</div>
												</>
											)}
											{
												<>
													<div className='flex items-center justify-between'>
														<div className='font-bold'>{getValue('app_v2_vip_reserve_modal_total_discount')}</div>
														<div className='font-bold'>{totalDiscount}</div>
													</div>
												</>
											}
										</AccordionItem>
									</Accordion>
									<div className='flex flex-col gap-0 w-full font-normal px-1'>
										<div className='flex gap-1 items-center text-xs opacity-70'>
											<div className=''>{getValue('app_v2_vip_reserve_modal_total_items_price')}:</div>
											<div className='grow text-right flex justify-end gap-2'>
												<NumberFlow value={sumPrice} suffix=' Ft' />
											</div>
										</div>
										<div className='flex gap-1 items-center text-xs opacity-70'>
											<div className=''>{getValue('app_v2_vip_reserve_modal_total_deposit_price')}:</div>
											<div className='grow text-right flex justify-end gap-2'>
												<NumberFlow value={sumDepositPrice} suffix=' Ft' />
											</div>
										</div>
										<div className='flex gap-1 items-center text-xs opacity-70'>
											<div className=''>{getValue('app_v2_vip_reserve_modal_total_packagingDiscountPrice')}:</div>
											<div className='grow text-right flex justify-end gap-2'>
												<NumberFlow value={packagingDiscountPrice} suffix=' Ft' separator=' ' />
											</div>
										</div>
										<div className='flex gap-1 items-center text-xs opacity-70'>
											<div className=''>{getValue('app_v2_vip_reserve_modal_total_deliveryCost')}:</div>
											<div className='grow text-right flex justify-end gap-2'>
												<NumberFlow value={deliveryCost} suffix=' Ft' />
											</div>
										</div>
										<div className='flex gap-1 items-center text-xs opacity-70'>
											<div className=''>{getValue('app_v2_vip_reserve_modal_total_serviceFee')}:</div>
											<div className='grow text-right flex justify-end gap-2'>
												<NumberFlow value={sumServiceFee - (deductFromPayment - totalDiscount)} suffix=' Ft' />
											</div>
										</div>
										<div className='flex gap-1 items-center text-xs opacity-70'>
											<div className=''>{getValue('app_v2_vip_reserve_modal_total_deductFromPayment')}:</div>
											<div className='grow text-right flex justify-end gap-2'>
												<NumberFlow value={totalDiscount} suffix=' Ft' />
											</div>
										</div>
										<div className='flex justify-between  font-bold'>
											<span>{getValue('app_v2_vip_reserve_modal_paymentsNeeded')}</span>
											<NumberFlow value={paymentsNeeded - deductFromPayment} suffix=' Ft' separator=' ' format={{style: 'decimal'}} />
										</div>
									</div>
								</>
							)}
						</DrawerHeader>
						<DrawerFooter className='flex flex-col w-full justify-between gap-2 items-center'>
							<BarSoftButton color='success' onPress={() => handleOk()} fullWidth forceCustom={true}>
								{getValue('app_v2_vip_reserve_modal_ok')}
							</BarSoftButton>
							<BarSoftButton color='danger' variant='bordered' onPress={() => handleCancel()} fullWidth={true} forceCustom={true}>
								{getValue('app_v2_vip_reserve_modal_close')}
							</BarSoftButton>
						</DrawerFooter>
					</>
				)}
			</DrawerContent>
		</Drawer>
	);
}
